import Script from 'next/script'

declare global {
	interface Window {
		Kustomer?: any
	}
}

export interface ISupportChat {}

const SupportChat: React.FC = () => {
	return (
		<Script
			strategy="afterInteractive"
			id="hyperlight-load-script"
			data-kustomer-api-key="eyJhbGciOiJub25lIn0.eyJvcmciOiI1YjMyYzY3NTlhZjY5ZjcyM2U4NjE1MjUiLCJvcmdOYW1lIjoiZWlnaHRzbGVlcCIsInJvbGVzIjpbIm9yZy50cmFja2luZyJdfQ."
			src="https://cdn.kustomerapp.com/chat-web/widget.js"
			onLoad={() => {
				window.Kustomer.start({
					brandId: '65171f7f36cbabb9f1ed93f0',
				})
				console.log('Kustomer loaded')
			}}
		></Script>
	)
}

export default SupportChat
